import * as StringUtils from '../../../utils/string-utils';
import serverValidationErrorsTemplate from './server-validation-errors.tpl.html';
import './server-validation-errors.less';
import { formGroupMessagesComponentModule } from '../form-group-messages/form-group-messages';

const ERRORS_CHANGED_EVENT = 'serverValidationService.errorsChanged';

export const serverValidationErrorsComponentModule = angular
  .module('Q.components.forms.server-validation-errors', [
    formGroupMessagesComponentModule,
  ])

  .factory('serverValidationService', function ($rootScope, $q) {
    let _msg = null;
    let _errors;

    const svc = {
      getErrorHandler,
      setErrors(errors, msg = null) {
        if (angular.isString(errors)) {
          _errors = [];
          _msg = errors;
        } else {
          _errors = errors;
          _msg = msg;
        }
        $rootScope.$broadcast(ERRORS_CHANGED_EVENT, _errors, _msg);
      },
      clearErrors(resp) {
        _msg = null;
        _errors = null;
        $rootScope.$broadcast(ERRORS_CHANGED_EVENT, _errors, _msg);
        return $q.when(resp);
      },
      getErrors() {
        return _errors;
      },
      getMessage() {
        return _msg;
      },
    };

    return svc;

    /**
     * Returns an HTTP response (catch) handler.  Note: this is not to intended to be used on $http().error(),
     * use it on `.catch(err)` or `.then(..., err)`.
     *
     * If provided a status code, or an array of status codes, or regular expressions that can test status
     * codes, these codes will be ignored and passed on unmodified.
     *
     * @param ignoredCodes one or an array of 40x status codes to ignore
     * @returns {Function}
     */
    function getErrorHandler({ ignoredCodes = [] } = {}) {
      if (!Array.isArray(ignoredCodes)) {
        ignoredCodes = [ignoredCodes];
      }
      return function (resp) {
        svc.clearErrors();
        if (resp && resp.status === 0) {
          // handle server communication errors (network down, unreachable, etc)
          svc.setErrors('There was a communication problem with the server.');
        } else if (resp && resp.status >= 500 && resp.status < 600) {
          // unrecoverable server errors
          svc.setErrors(
            { '': resp.statusText },
            'There was an error on the server we could not continue from.',
          );
        } else if (resp && resp.status >= 400 && resp.status < 500) {
          // client errors
          if (
            resp.data &&
            !ignoredCodes.some(
              (code) =>
                resp.status === code || (code.test && code.test(resp.status)),
            )
          ) {
            if (resp.data.errors) {
              svc.setErrors(resp.data.errors);
            } else if (resp.data.reason) {
              svc.setErrors(resp.data.reason);
            }
          }
        }

        return $q.reject(_errors ? null : resp);
      };
    }
  })

  /**
   * Directive to render server validation errors on every model on the form.
   */
  .directive('serverValidationErrors', function (FORM_GROUP_MESSAGES) {
    FORM_GROUP_MESSAGES.add('serverValidation', ($input, formGroupField) => {
      return `${formGroupField.nameCapitalized} ${formGroupField.serverValidationMessage || 'has an unknown server validation error'}`;
    });

    return {
      restrict: 'AE',
      require: '^form',
      template: serverValidationErrorsTemplate,
      scope: true,
      controller() {},
      link(scope, elem, attrs, ngFormCtrl) {
        let activeErrors = [];
        let base = attrs.serverValidationObject;

        scope.$on(ERRORS_CHANGED_EVENT, function ($event, errs, msg) {
          scope.serverErrorsMessage = msg;
          scope.serverErrors = [];

          angular.forEach(activeErrors, (key) => {
            ngFormCtrl[key].$setValidity('serverValidation', true);
          });
          activeErrors = [];

          if (errs) {
            ngFormCtrl.$setSubmitted();
            angular.forEach(errs, (err, key) => {
              if (
                ngFormCtrl.serverValidationMap &&
                ngFormCtrl.serverValidationMap[key]
              ) {
                key = ngFormCtrl.serverValidationMap[key];
              }

              let field = ngFormCtrl[key],
                baseKey = `${base}.${key}`;

              if (base && ngFormCtrl[baseKey]) {
                key = baseKey;
                field = ngFormCtrl[baseKey];
              }

              if (angular.isArray(err)) {
                err = err.join(', ');
              }

              if (field) {
                // whenever possible, render errors at their point of origin
                ngFormCtrl[key].$setValidity('serverValidation', false);
                if (
                  ngFormCtrl[key].formGroupCtrl &&
                  ngFormCtrl[key].formGroupCtrl.formGroupField
                ) {
                  ngFormCtrl[
                    key
                  ].formGroupCtrl.formGroupField.serverValidationMessage = err;
                }
                activeErrors.push(key);
              } else {
                // otherwise, render them in a generic list
                scope.serverErrors.push({
                  field: StringUtils.upperCaseWords(
                    StringUtils.fieldToLabel(key),
                  ),
                  message: err,
                });
              }
              if (ngFormCtrl.scrollToError) {
                ngFormCtrl.scrollToError();
              }
            });
          }
        });
      },
    };
  })

  // clears any server validation errors if the field is updated
  // (otherwise the form might not be able to submit)
  .directive('ngModel', function () {
    return {
      restrict: 'A',
      require: ['ngModel', '?^form', '?^^formGroup'],
      link(scope, elem, attrs, [ngModelCtrl, ngFormCtrl, formGroupCtrl]) {
        if (formGroupCtrl) {
          ngModelCtrl.formGroupCtrl = formGroupCtrl;

          let last = null;

          if (ngFormCtrl && attrs.serverValidationKey) {
            if (!ngFormCtrl.serverValidationMap) {
              ngFormCtrl.serverValidationMap = {};
            }
            ngFormCtrl.serverValidationMap[attrs.serverValidationKey] =
              attrs.name;
          }

          ngModelCtrl.$parsers.push((value) => {
            if (value !== last) {
              ngModelCtrl.$setValidity('serverValidation', true);
              last = value;
            }
            return value;
          });
        }
      },
    };
  });
